import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    "Supabase credentials not found. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.",
  );
}

// Create client without schema option - we'll use .schema() on each query
const supabaseClient = createClient(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseKey || "placeholder-key",
);

// Helper to create queries on the cbm_events schema
export const supabase = {
  auth: supabaseClient.auth,
  storage: supabaseClient.storage,
  from: (table: string) => supabaseClient.schema("cbm_events").from(table),
  rpc: (fn: string, args?: Record<string, unknown>) =>
    supabaseClient.schema("cbm_events").rpc(fn, args),
};
